var version = {
    "name":      "dativery",
    "buildDateCode": "20260806-111148",
    "buildDate": "Thu Aug 06 2026 11:11:48 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260806-111148",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;